import { usePromo } from '@entities/promo-video';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { usePromoLoader } from '@features/promo-videos';
import { type PromoVideo } from '@shared/types/promo-videos';
import { Card } from '@shared/ui';
import { AddPromoBtn } from './add-promo-btn';
import { PromoInfoBtn } from './promo-info-btn';
import st from './styles.module.scss';
import { usePromoEditPageRedirect } from '@pages/programs/promo-edit/helpers.ts';

interface Props {
  onRedirect?: () => void;
  promoId: number;
  onPromoChange: (promoId: number) => void;
  onRemove: () => void;
}

export const EditorLoadPromo: React.FC<Props> = ({
  onRedirect,
  promoId,
  onPromoChange,
  onRemove,
}) => {
  const [promoVideo, setPromoVideo] = useState<PromoVideo | null>(null);
  usePromoLoader(promoId);
  const { promo } = usePromo(promoId);
  const { doSavePageUrl } = usePromoEditPageRedirect();
  // console.log('promoIdFromEditor:',promoId);
  // console.log('promo:',promo);

  useEffect(() => {
    if (promoId > 0 && promo) {
      setPromoVideo(promo);
      onPromoChange && onPromoChange(promo.id);
      // setValue('promo_video', promo.id);
    } else {
      setPromoVideo(null);
    }
  }, [promo, promoId]);

  const handleClickAddPromo = () => {
    onRedirect && onRedirect();
    doSavePageUrl();
  };

  return (
    <section className={st.editLoadPromo}>
      <h3 className={st.editLoadPromo__heading}>Трейлер</h3>
      <Card className={`${st.card} ${promoVideo ? st.link : ''}`}>
        {promoVideo ? (
          <PromoInfoBtn promo={promoVideo} onRemove={onRemove} />
        ) : (
          <AddPromoBtn onAdd={handleClickAddPromo} />
        )}
      </Card>
    </section>
  );
};
